import React, { RefObject } from "react";
import { Camera } from "react-camera-pro";
import { IconCamera, IconUpload } from "@tabler/icons-react";

type Props = {
    cameraRef: RefObject<any>;
    fileInputRef: RefObject<HTMLInputElement>;
    onCapture: () => void;
    onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const VoterPhotoCameraStep = ({ cameraRef, fileInputRef, onCapture, onFileChange }: Props) => (
    <>
        <div className="relative mx-auto aspect-[4/3] w-full max-w-xl overflow-hidden rounded-xl bg-black">
            <Camera
                ref={cameraRef}
                facingMode="user"
                aspectRatio={4 / 3}
                errorMessages={{
                    noCameraAccessible:
                        "Camera could not be accessed. Please allow camera permission or upload a photo.",
                    permissionDenied:
                        "Camera permission was denied. Please allow camera access or upload a photo.",
                    switchCamera: "Unable to switch camera.",
                    canvas: "Camera is not supported by this browser.",
                }}
            />
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
            <button
                type="button"
                onClick={onCapture}
                className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-700"
            >
                <IconCamera size={18} />
                Capture
            </button>
            <button
                type="button"
                onClick={() => fileInputRef.current?.click()}
                className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
                <IconUpload size={18} />
                Upload Photo
            </button>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={onFileChange}
            />
        </div>
    </>
);

export default VoterPhotoCameraStep;
